import { Component, OnInit , NgZone} from '@angular/core';
import { AppService } from './app.service';
import { NbSidebarService, NbMenuService } from '@nebular/theme';
import { AuthService } from './auth.service';
import { filter, map } from 'rxjs/operators';

let body1 = '{ "product":"CARBONATO DE LITIO", "input":"usfob", "company":"SQM", "calcmt":"original", "frecuency":"month", "datefrom":"2017-01-01", "dateto":"2018-12-31", "origin":"CHILE","destiny":"" }';
let body2 = '{ "product":"", "input":"usfob", "calcmt":"original", "frecuency":"month", "datefrom":"2017-01-01", "dateto":"2018-12-31", "origin":"ARGENTINA","destiny":"" }';
let body3 = '{ "product":"", "input":"usfob", "calcmt":"original", "frecuency":"month", "datefrom":"2017-01-01", "dateto":"2018-12-31", "origin":"CHILE","destiny":"CHINA" }';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [AppService]
})

export class AppComponent {
    title = 'SignumBox - Limetrics';
    chartData = body1;
    data: any = []
    usfob: number[] = []
    tonnes: number[] = []
    public labels: string[] =[]
    isDataAvailable: boolean =false;
    user: any;
    profile = [
    { title: 'Profile' },
    { title: 'Logout' },
  ];

    constructor( private nbService: NbSidebarService, private nbMenuService: NbMenuService, public auth: AuthService) {

     }

    ngOnInit() {
         this.auth.user$.subscribe(user => {
         this.user= user;
       })

       // this.nbMenuService.onItemClick()
       // .pipe(
       //   filter(({ tag }) => tag === 'my-context-menu'),
       //   map(({ item: { title } }) => title),
       // )
       // .subscribe(title => this.contextMenu(title) );
     }
    toggle() {
      this.nbService.toggle(true, 'left');
    }

    contextMenu(title) {
      console.log(title);

      if(title=='Profile') {
        console.log('profile');
        }

      else if (title=='Logout') {
        console.log('logout');
        //this.auth.signOut();
      }
    }
    //public months:string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    //public pieChartLabels:string[] = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    //public pieChartData:number[] = [4.223, 2.820, 2.885, 4.893, 4.888, 3.490, 2.416, 3.687, 3.597, 1.913, 3.272, 2.133];
    public pieChartLabels:string[] =[];
    public pieChartType:string = 'line';
    public pieChartData:any[] = [];

    public pieChartOptions:any = {
      'backgroundColor': ["#FF6384", "#4BC0C0","#FFCE56","#E7E9ED","#36A2EB"],
      responsive: true,
          scales: {
          yAxes: [{
            type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'MT (Million Tonnes)'
            },
            position: 'left',
            id: 'y-axis-1',
          } //, {
          //   type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
          //   display: true,
          //   scaleLabel: {
					// 		display: true,
					// 		labelString: 'US$'
					// 	},
          //   position: 'right',
          //   id: 'y-axis-2',
          //
          //   // grid line settings
          //   gridLines: {
          //     drawOnChartArea: false, // only want the grid lines for one axis to show up
          //   },
           ],
        } };
  }
